import { Text, View } from '@react-pdf/renderer';

import { commonStyles } from 'src/common/pdf/common.styles';
import { currencyFormatter } from 'src/features/billing/invoices/forms/cells/utils';
import { styles } from 'src/features/billing/invoices/pdf/styles';
import { HydratedInvoiceRefundRow } from 'src/features/billing/invoices/types';

import { ExpandedRefundsTable } from './ExpandedRefundsTable';

interface ExpandedRefundsLineProps {
  refundAmount: number;
  refunds: HydratedInvoiceRefundRow[];
}
export function ExpandedRefundsLine({
  refundAmount,
  refunds,
}: ExpandedRefundsLineProps) {
  return (
    <>
      <View
        style={[
          styles.subTotalStyle,
          { flexDirection: 'column', justifyContent: 'flex-start' },
        ]}
      >
        <Text style={commonStyles.strong}>Refunds</Text>
        <ExpandedRefundsTable data={refunds} />
      </View>
      <View style={[styles.subTotalStyle]}>
        <Text style={commonStyles.strong}>Total Refunds</Text>
        <Text>{currencyFormatter(refundAmount)}</Text>
      </View>
    </>
  );
}
